import api from './api'
import { defActionSlice } from '../../../../helpers/defaultAction'
import { reCorrectionFactorReducer } from './reducer'

const {
    setLoading,
    setError,
    getListSuccess,
    clear
} = reCorrectionFactorReducer.actions

export const getCorrectionFactors = (values) => {
	const defObj = {
		req: setLoading,
		suc: getListSuccess,
		fail: setError,
		service: {
			params: values,
			func: api.getList
		}
	}
	return defActionSlice(defObj)
}

export const clearAction = (values) => {
	const defObj = {
		req: clear,
	}
	return defActionSlice(defObj)
}
